<section #formStart class="desk:centered-1170-with-padding pb-14 pt-7">
  @let isSubmitted = isFormSubmitted();
  @let isInvalid = isFormValid().status === "KO";
  @let errors = isFormValid().errors!;
  @let questionSection = data.questionSection;
  @let firstQuestion = questionSection.firstQuestion;
  <div class="rounded-[35px] bg-anis py-10 desk:px-11">
    <div class="pb-10 pl-5 pr-[52px]">
      <app-title [title]="{ text: firstQuestion.text, as: 'span' }" size="h2" />
      @if (isSubmitted && isInvalid && errors.interest) {
        <div class="text-[10px] text-error">
          {{ errors.interest | translate }}
        </div>
      }
    </div>
    <div class="no-scrollbar w-screen overflow-x-auto pb-12 desk:w-auto">
      <div class="inline-flex w-full flex-nowrap gap-x-6 pl-8 desk:justify-between">
        @for (option of firstQuestion.options; track i; let i = $index) {
          <div class="flex w-[207px] shrink-0 flex-col items-center gap-y-2.5">
            <app-svg [src]="option.picto.svg" [style.transform]="stickerRotations[i]" [width]="138" class="block" />
            <div class="flex items-center gap-x-2">
              @let id = `interest-${i}`;
              <div class="size-6">
                <input
                  (input)="onInputChange($event)"
                  [checked]="interest() === option.text"
                  [id]="id"
                  [value]="option.text"
                  class="size-5 cursor-pointer"
                  name="interest"
                  type="radio" />
              </div>
              <label [for]="id" class="cursor-pointer">{{ option.text }}</label>
            </div>
          </div>
        }
      </div>
    </div>
    @let secondQuestion = questionSection.secondQuestion;
    <div class="pl-5 pr-[52px]">
      <app-title [title]="{ text: secondQuestion.text, as: 'span' }" size="h2" />
      <div class="pb-2">{{ secondQuestion.subtext }}</div>
      <div class="flex flex-col gap-x-6 gap-y-2 desk:flex-row">
        @for (i of 3 | generateRange; track i) {
          @let descriptionId = `description-${i}`;
          <div class="desk:grow">
            <label [for]="descriptionId" class="mb-1 block font-bold">#{{ i + 1 }}</label>
            <input
              (input)="onInputChange($event)"
              [id]="descriptionId"
              [value]="describeYourself()[i]"
              class="h-7 w-full rounded-[10px] border bg-transparent px-4 py-5"
              type="text" />
          </div>
        }
      </div>
    </div>
  </div>
  @let formSection = data.formSection;
  <div
    class="mt-9 grid grid-cols-1 gap-x-7 rounded-[35px] bg-gray-light px-5 pb-16 pt-10 desk:grid-cols-[400px_1fr] desk:px-11">
    <div class="mb-7 flex flex-col gap-y-7">
      <app-title [title]="{ text: formSection.title, as: 'span' }" size="h2" />
      <div class="flex flex-col gap-y-4">
        <div class="relative">
          <label class="mb-1 block font-bold" for="area">{{
            "COMPONENT.FORMULAIRE-CONTACT-B2B.LABEL_AREA" | translate
          }}</label>
          <app-select (optionSelected)="onAreaSelected($event)" [displayAsBlock]="true" [options]="availableAreas()" />
          @if (isSubmitted && isInvalid && errors.selectedArea) {
            <div class="absolute -bottom-4 text-[10px] text-error">
              {{ errors.selectedArea | translate }}
            </div>
          }
        </div>
        <div class="relative">
          <label class="mb-1 block font-bold" for="last-name">{{
            "COMPONENT.FORMULAIRE-CONTACT-B2B.LABEL_LAST_NAME" | translate
          }}</label>
          <input
            (input)="onInputChange($event)"
            [value]="lastName()"
            class="h-7 w-full rounded-[10px] border bg-transparent px-4 py-5"
            id="last-name"
            maxlength="255"
            type="text" />
          @if (isSubmitted && isInvalid && errors.lastName) {
            <div class="absolute -bottom-4 text-[10px] text-error">
              {{ errors.lastName | translate }}
            </div>
          }
        </div>
        <div class="relative">
          <label class="mb-1 block font-bold" for="first-name">{{
            "COMPONENT.FORMULAIRE-CONTACT-B2B.LABEL_FIRST_NAME" | translate
          }}</label>
          <input
            (input)="onInputChange($event)"
            [value]="firstName()"
            class="h-7 w-full rounded-[10px] border bg-transparent px-4 py-5"
            id="first-name"
            maxlength="255"
            type="text" />
          @if (isSubmitted && isInvalid && errors.firstName) {
            <div class="absolute -bottom-4 text-[10px] text-error">
              {{ errors.firstName | translate }}
            </div>
          }
        </div>
        <div class="relative">
          <label class="mb-1 block font-bold" for="email">{{
            "COMPONENT.FORMULAIRE-CONTACT-B2B.LABEL_EMAIL" | translate
          }}</label>
          <input
            (input)="onInputChange($event)"
            [value]="email()"
            class="h-7 w-full rounded-[10px] border bg-transparent px-4 py-5"
            id="email"
            maxlength="255"
            type="email" />
          @if (isSubmitted && isInvalid && errors.email) {
            <div class="absolute -bottom-4 text-[10px] text-error">
              {{ errors.email | translate }}
            </div>
          }
        </div>
        <div class="relative">
          <label class="mb-1 block font-bold" for="phone">{{
            "COMPONENT.FORMULAIRE-CONTACT-B2B.LABEL_PHONE" | translate
          }}</label>
          <input
            (input)="onInputChange($event)"
            [value]="phone()"
            class="h-7 w-full rounded-[10px] border bg-transparent px-4 py-5"
            id="phone"
            maxlength="20"
            type="tel" />
          @if (isSubmitted && isInvalid && errors.phone) {
            <div class="absolute -bottom-4 text-[10px] text-error">
              {{ errors.phone | translate }}
            </div>
          }
        </div>
      </div>
      <div>
        <div class="mb-4 font-bold">{{ "COMPONENT.FORMULAIRE-CONTACT-B2B.LABEL_MESSAGE" | translate }}</div>
        <label for="comments">{{ "COMPONENT.FORMULAIRE-CONTACT-B2B.MESSAGE_HELPER_TEXT" | translate }}</label>
        <div class="relative mb-6 mt-4">
          <textarea
            (input)="onInputChange($event)"
            [value]="project()"
            class="h-36 w-full rounded-[10px] border bg-transparent px-4 py-5"
            id="comments"
            maxlength="1000"></textarea>
          @if (isSubmitted && isInvalid && errors.message) {
            <div class="absolute -bottom-4 text-[10px] text-error">
              {{ errors.message | translate }}
            </div>
          }
        </div>
        <div [innerHTML]="formSection.legalNotice" class="prose prose-sm mb-2.5 w-5/6" handleHtmlLinks></div>
        @let submitButton = data.formSection.submitButton;
        <app-button
          (onButtonClick)="onSubmit(submitButton.label)"
          [isLoading]="isSending()"
          [label]="submitButton.label" />
      </div>
    </div>

    <div class="flex h-fit flex-col items-center rounded-[35px] bg-white py-5 text-center">
      <div class="px-6">
        <div class="mb-4 font-bold">{{ "COMPONENT.FORMULAIRE-CONTACT-B2B.DEVELOPER_SECTION_TITLE" | translate }}</div>
        <div class="mb-[70px]">
          {{ "COMPONENT.FORMULAIRE-CONTACT-B2B.DEVELOPER_SECTION_DESCRIPTION" | translate }}
        </div>
      </div>
      <div
        [class.desk:grid-cols-2]="filteredDevelopers().length > 1"
        class="grid w-full grid-cols-1 justify-between gap-x-2.5 gap-y-8 text-center">
        @for (developer of filteredDevelopers(); track developer.email) {
          <div>
            <div class="relative mx-auto size-32">
              <div class="size-full overflow-hidden rounded-[14px]">
                <app-image
                  [image]="developer.picture"
                  [isPriority]="!isImageInPreviousBlocks && $index < 2"
                  [pregenerationSize]="{ width: 128, height: 128 }" />
              </div>
              <a [href]="developer.linkedinUrl" class="absolute -right-4 -top-2.5 block rotate-[5deg]" target="_blank">
                <app-svg [height]="41" [width]="35" src="assets/icons/linkedin-pill.svg" />
              </a>
            </div>
            <div class="my-2 font-bold">{{ developer.name }}</div>
            <a [href]="`mailto:${developer.email}`">{{ developer.email }}</a>
            <div>{{ developer.phone }}</div>
          </div>
        }
      </div>
    </div>
  </div>
  @let appointmentSection = data.appointmentSection;
  @if (appointmentSection && appointmentSection.title) {
    <div class="mx-auto -mt-6 w-5/6 rounded-[35px] bg-purple px-5 py-6 desk:mr-11 desk:w-[427px]">
      <div class="title-h2 mb-2.5">{{ appointmentSection.title }}</div>
      <div class="mb-6">{{ appointmentSection.text }}</div>
      @let cta = appointmentSection.cta;
      <app-button [label]="cta.label" [url]="cta.url"></app-button>
    </div>
  }
</section>
